enum Court {
  VwGH = 'VwGH',
  VfGH = 'VfGH',
  OGH = 'OGH',
  BGBL = 'BGBL',
  EuGH = 'EuGH',
}

const risLinkMapping: Record<Court, string> = {
  VwGH: 'Vwgh',
  VfGH: 'Vfgh',
  OGH: 'Justiz',
  BGBL: 'BgblPdf',
  EuGH: 'EuGH',
}

const sanitizeGzId = (court: Court, id: string) => {
  switch (court) {
    case 'OGH':
    case 'VfGH':
      return id.replace(/\s/g, '')
    default:
      return id
  }
}

const getGZ = (urteil: string, mappedCourt: [Court, string]) => {
  const gz = urteil.substring(mappedCourt[0].length + 1)
  return sanitizeGzId(mappedCourt[0], gz)
}
const getMappedCourt = (urteil: string): [Court, string] | null => {
  const courts = Object.keys(risLinkMapping) as Court[]
  for (const court of courts) {
    if (urteil.startsWith(court)) {
      return [court, risLinkMapping[court]]
    }
  }
  return null
}

export const buildUrteilLink = (urteil: string | null | undefined) => {
  if (!urteil) {
    return null
  }
  const mappedCourt = getMappedCourt(urteil) || [Court.OGH, risLinkMapping[Court.OGH]]
  const gz = getGZ(urteil, mappedCourt)

  if (mappedCourt[0] === Court.EuGH) {
    return `https://curia.europa.eu/juris/liste.jsf?num=${encodeURIComponent(gz)}`
  }

  return `https://www.ris.bka.gv.at/Ergebnis.wxe?Abfrage=${mappedCourt[1]}&SucheNachRechtssatz=False&SucheNachText=True&GZ=${gz}&ResultPageSize=10&SkipToDocumentPage=true`
}
